import { useDispatch } from "react-redux";
import "./../App.css"
import { addCashAction, removeCashAction, returnCashAction } from "../Redux/cashReducer";

const Cash = () => {

    const dispatch = useDispatch();

    const addCash = (value) => {
        dispatch(addCashAction(value))
    }
    const removeCash = (value) => {
        dispatch(removeCashAction(value))
    }

    return (
        <div className="btn">
            <button onClick={() => addCash(Number(prompt()))}>Add cash</button>
            <button onClick={() => removeCash(Number(prompt()))}>Remove Cash</button>
            <button onClick={() => dispatch(returnCashAction())}>Return cash</button>
        </div>
    )
}


export default Cash;